const description= [

{ 
label:"Description",
controlType:"text area",
options:[]
}

]

export default description